import moment from "moment";
import { useContext } from "react";
import DraftStateContext from "../../../contexts/draftStateContext";
import useDraftCountdownClock from "../../useDraftCountdownClock";
import useDraftPicks from "./useDraftPicks";
import useDraftSettings from "./useDraftSettings";

export default function useDraftOnClock() {
  const draftState = useContext(DraftStateContext);
  const { hasStarted, pickNumOnClock } = draftState.info;
  const { draftSettingsData } = useDraftSettings();
  const { draftPicksData } = useDraftPicks();

  let pickOnClockStartDate = null;
  if (hasStarted && draftPicksData) {
    const pick = draftPicksData.picks[pickNumOnClock - 1];
    if (pick) pickOnClockStartDate = pick.onClockDate;
  }
  let pickOnClockEndDate = null;
  if (pickOnClockStartDate && draftSettingsData) {
    pickOnClockEndDate = moment(pickOnClockStartDate)
      .add(draftSettingsData.settings.secondsPerPick + 5, "seconds")
      .format();
  }

  return useDraftCountdownClock(pickOnClockEndDate);
}
